import { inject, observer } from "mobx-react";
import { Form } from "react-bootstrap";
import "./information.scss";

import { Formik } from "formik";

import { refreshUserDataMain } from "../../Validation/index";

import "react-phone-input-2/lib/style.css";
import LoadedComponent from "../LoadedComponent/index";

const Main = ({ userData, refreshUserData, isLoading, newData }) => {
  return (
    <LoadedComponent isLoading={isLoading}>
      <>
        <Formik
          initialValues={{
            surname: userData["surname"] ? userData["surname"] : "",
            name: userData["name"] ? userData["name"] : "",
            patronymic: userData["patronymic"] ? userData["patronymic"] : "",
            birthday: userData["birthday"] ? userData["birthday"] : "",
            phone: userData["phone"] ?? "",
            email: userData["email"] ? userData["email"] : "",
            password: "",
            confirmPassword: "",
            contract_type: userData["contract_type"]
              ? userData["contract_type"]
              : "",
            birth_place: userData["birth_place"] ? userData["birth_place"] : "",
            passport_number: userData["passport_number"]
              ? userData["passport_number"]
              : "",
            passport_series: userData["passport_series"]
              ? userData["passport_series"]
              : "",
            passport_code: userData["passport_code"]
              ? userData["passport_code"]
              : "",
            passport_date: userData["passport_date"]
              ? userData["passport_date"]
              : "",
            passport_place: userData["passport_place"]
              ? userData["passport_place"]
              : "",
            passport_propiska: userData["passport_propiska"]
              ? userData["passport_propiska"]
              : "",
            snils: userData["snils"] ? userData["snils"] : "",
            inn: userData["inn"] ? userData["inn"] : "",
            bankaccount: userData["bank_payment_account"]
              ? userData["bank_payment_account"]
              : "",
            bankname: userData["bank_name"] ? userData["bank_name"] : "",
            banknumber: userData["bank_inn"] ? userData["bank_inn"] : "",
            bankbik: userData["bank_bik"] ? userData["bank_bik"] : "",
            bankkpp: userData["bank_kpp"] ? userData["bank_kpp"] : "",
            bankkor: userData["bank_correspondent_account"]
              ? userData["bank_correspondent_account"]
              : "",
            bank_recipient: userData["bank_recipient"]
              ? userData["bank_recipient"]
              : ""
          }}
          validateOnBlur
          onSubmit={async (values) => {
            await refreshUserData(values);
            newData();
          }}
          validationSchema={refreshUserDataMain}
        >
          {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            dirty
          }) => (
            <Form className="information-form">
              <Form.Group className="mb-3">
                <div className="form__col form__mainstatus information-form-subtitle">
                  <p className="information-placeholder-mainstatus ">
                    {" "}
                    Статус профиля:{" "}
                  </p>
                  <p className="form__col-successsubtitle">
                    {userData["moderated"] === "1"
                      ? "Подтвержден"
                      : "Зарегистрирован"}{" "}
                  </p>
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Фамилия"
                  name="surname"
                  onFocus={() => setFieldTouched("surname", true, true)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.surname}
                  isInvalid={touched.surname && errors.surname}
                  className="information-placeholder"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.surname}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Имя"
                  name="name"
                  onFocus={() => setFieldTouched("name", true, true)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  isInvalid={touched.name && errors.name}
                  className="information-placeholder"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Отчество"
                  name="patronymic"
                  onFocus={() => setFieldTouched("patronymic", true, true)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.patronymic}
                  isInvalid={touched.patronymic && errors.patronymic}
                  className="information-placeholder"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.patronymic}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="date" className="mb-3">
                <Form.Label className="information-form-subtitle">
                  Дата рождения
                </Form.Label>
                <Form.Control
                  type="date"
                  max="2999-12-31"
                  name="birthday"
                  onFocus={() => setFieldTouched("birthday", true, true)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.birthday}
                  isInvalid={touched.birthday && errors.birthday}
                  className="information-placeholder"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.birthday}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="form__col form__mainstatus information-form-subtitle marginBottom">
                <p className="information-placeholder-mainstatus ">
                  {" "}
                  Телефон:{" "}
                </p>
                <p className="form__col-successsubtitle">{userData["phone"]}</p>
                <p className="form__col-successsubtitle">
                  {userData["phone_approved"] === "1" ? (
                    <span className="form__col-successsubtitle">
                      Подтверждён{" "}
                    </span>
                  ) : (
                    ""
                  )}
                </p>
              </div>
              <Form.Group className="mb-3" controlId="formGridEmail">
                <Form.Label className="information-form-subtitle">
                  Электронная почта*
                </Form.Label>

                <Form.Control
                  className="information-placeholder"
                  type="email"
                  placeholder="Email"
                  name="email"
                  onFocus={() => setFieldTouched("email", true, true)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  isInvalid={touched.email && errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="information-row">
                <Form.Group className="mb-3">
                  <Form.Label className="information-form-subtitle">
                    Задать новый пароль
                  </Form.Label>
                  <Form.Control
                    className="information-placeholder"
                    type="password"
                    placeholder="Пароль"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    isInvalid={touched.password && errors.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className=" information-form-subtitle">
                    Подтвердить пароль
                  </Form.Label>
                  <Form.Control
                    className="information-placeholder"
                    type="password"
                    placeholder="Подтвердить пароль"
                    name="confirmPassword"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.confirmPassword}
                    isInvalid={
                      touched.confirmPassword && errors.confirmPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  disabled={!dirty}
                  onClick={handleSubmit}
                  className="information-mainbtn information-mainbtn_save"
                >
                  Сохранить изменения
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    </LoadedComponent>
  );
};

export default inject(({ usersStore }) => {
  const { userData, refreshUserData, isLoading } = usersStore;

  return {
    userData,
    isLoading,
    refreshUserData
  };
})(observer(Main));
